import { render } from "./Snek.vue?vue&type=template&id=4a237dde"
import script from "./Snek.vue?vue&type=script&lang=js"
export * from "./Snek.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__